export class JhaSelectOption<T = string> {
    constructor(
        public readonly name: string,
        public readonly value: T
    ) {}
}
